:host {
  display: block;
  max-width: 100%;
}

.container-alerts {
  height: 30px;
  cursor: pointer;
}

gz-icon-label {
  width: 22px;
}

gz-icon-label::part(button) {
  height: 100%;
}

.container-alerts:hover {
  background-color: var(--chart-051-hover);
}
